import { NonEmptyString } from 'io-ts-types';
import {
    Environment,
    FinishedVehicleQueryResult,
    NaturalLanguageQuery,
    SelectedContext,
} from '../dataqueries/dataQuery.types';
import {
    ApiEnvironment,
    ApiFinishedVehicleQueryResult,
    ApiNaturalLanguageQuery,
    ApiSelectedContext,
} from './dataQueryApi.types';

export const mapToApiNaturalLanguageQuery = (parameters: NaturalLanguageQuery): ApiNaturalLanguageQuery => ({
    query: parameters.query as NonEmptyString,
    selected_context: mapToApiSelectedContext(parameters.selectedContext),
    environment: mapToApiEnvironment(parameters.environment),
    limit: parameters.limit,
});

const mapToApiSelectedContext = (selectedContext: SelectedContext): ApiSelectedContext => {
    switch (selectedContext) {
        case SelectedContext.TRANSPORT_ORDER:
            return ApiSelectedContext.TRANSPORT_ORDER;
        case SelectedContext.TRANSPORT_CAPACITY_ORDER:
            return ApiSelectedContext.TRANSPORT_CAPACITY_ORDER;
        case SelectedContext.COMPOUND_VEHICLE:
            return ApiSelectedContext.COMPOUND_VEHICLE;
        case SelectedContext.SERVICE_OPTION:
            return ApiSelectedContext.SERVICE_OPTION;
        case SelectedContext.SERVICE_ORDER:
            return ApiSelectedContext.SERVICE_ORDER;
        case SelectedContext.VDA_SERVICE_ORDER:
            return ApiSelectedContext.VDA_SERVICE_ORDER;
        case SelectedContext.VDA_SERVICE_ORDER_RESPONSE:
            return ApiSelectedContext.VDA_SERVICE_ORDER_RESPONSE;
        case SelectedContext.VDA_TRANSPORT_CAPACITY_ORDER:
            return ApiSelectedContext.VDA_TRANSPORT_CAPACITY_ORDER;
        case SelectedContext.VDA_TRANSPORT_CAPACITY_ORDER_RESPONSE:
            return ApiSelectedContext.VDA_TRANSPORT_CAPACITY_ORDER_RESPONSE;
        case SelectedContext.VDA_TRANSPORT_ORDER:
            return ApiSelectedContext.VDA_TRANSPORT_ORDER;
        case SelectedContext.VDA_TRANSPORT_ORDER_RESPONSE:
            return ApiSelectedContext.VDA_TRANSPORT_ORDER_RESPONSE;
        case SelectedContext.VDA_TRANSPORT_STATUS_REPORTS:
            return ApiSelectedContext.VDA_TRANSPORT_STATUS_REPORTS;
        case SelectedContext.VDA_COMPOUND_TRANSPORT_ORDER:
            return ApiSelectedContext.VDA_COMPOUND_TRANSPORT_ORDER;
    }
};

const mapToApiEnvironment = (environment: Environment): ApiEnvironment => {
    switch (environment) {
        case Environment.QA:
            return ApiEnvironment.QA;
        case Environment.PROD:
            return ApiEnvironment.PROD;
    }
};

export const mapToFinishedVehicleQueryResult = (
    apiResult: ApiFinishedVehicleQueryResult,
): FinishedVehicleQueryResult => ({
    queryId: apiResult.query_id,
    limitExceeded: apiResult.limit_exceeded,
    items: apiResult.items,
});
